import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'metricConversion',pure:false })
export class MetricConversionPipe implements PipeTransform {
  constructor(private translateService:TranslateService){

  }
  transform(priceMetric:string, purchaseMetric:string) {
    let display:string = '';
    if(priceMetric =='piece'){
        display += this.translateService.instant('quantityMetric.short.'+purchaseMetric)
    }
    else{
        display += " "+this.translateService.instant('quantityMetric.short.'+priceMetric);
    }
    return display;
  }
}